import { clsx } from 'clsx'
import type { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'

import cancelledIcon from '{cImg}/assembly-statuses/canceled.svg'
import IntercomLink from '~/components/IntercomLink.tsx'
import { Text } from '~/components/Text.tsx'
import { useWorkspace } from '~/features/workspaces/data.ts'
import prettifyOnWhatDay from '~/utils/prettifyOnWhatDay.ts'
import Url from '~/utils/Url.ts'

import styles from './WorkspaceStatus.module.scss'
import { Outer, Content } from '../../components/Box.tsx'

const WorkspaceStatus = ({ children }: PropsWithChildren) => {
  const { data } = useWorkspace()
  const location = useLocation()

  const isBillingPage = location.pathname.includes('/billing')
  const isSettingsPage = location.pathname.includes('/settings')

  if (
    data?.workspace.cancelled &&
    !isBillingPage &&
    !isSettingsPage &&
    Url.isWorkspaceSpecificUrl(location.pathname)
  ) {
    return (
      <Outer>
        <Content className={clsx(styles.innerWrapper)}>
          <img
            src={cancelledIcon}
            alt="cancelled"
            className={clsx(styles.icon)}
            width={48}
            height={48}
          />
          <h3>This Workspace has been cancelled</h3>
          <Text align="center">
            The Workspace{' '}
            <Text asChild code>
              <code>{data.workspace.slug}</code>
            </Text>{' '}
            was cancelled on {prettifyOnWhatDay(data.workspace.cancelled)}. All functionality around
            Assemblies and Templates does not work. To uncancel it, please{' '}
            <IntercomLink
              message={`Hey, I would like to uncancel the Workspace "${data.workspace.slug}".`}
            >
              contact support
            </IntercomLink>
            .
          </Text>
        </Content>
      </Outer>
    )
  }

  return children
}

export default WorkspaceStatus
